import { useMemo } from 'react';
import { DeviationDto } from 'src/generated/services/TFinancialApi';
import { cn } from 'src/utils/utility';

interface ITabIconWrapperProps {
  status: DeviationDto['status'];
  children: React.ReactNode;
  isActive?: boolean;
  noBorder?: boolean;
}

export const TabIconWrapper: React.FC<ITabIconWrapperProps> = ({ status, isActive, children, noBorder }) => {
  const styles = useMemo(() => {
    if (noBorder) {
      return ['bg-white', 'rounded-full', 'w-25', 'h-25', 'flex', 'items-center', 'justify-center'];
    }

    if (isActive) return [];

    const styles = ['border'];
    switch (status) {
      case 'REJECTED_UNDONE':
        styles.push('border-blue_grey-30');
        break;
      case 'REJECTED_DONE':
        styles.push('border-red-40');
        break;
      case 'APPROVED_UNDONE':
        styles.push('border-blue_grey-30');
        break;
      case 'DONE':
        styles.push('border-primary');
        break;
      default:
        styles.push('border-blue_grey-30');
        break;
    }
    return styles;
  }, [isActive, status, noBorder]);

  return <span className={cn('bg-white rounded-full w-25 h-25 flex items-center justify-center', styles)}>{children}</span>;
};
